import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import RelationName from '@/shared/components/RelationName';
import { hasAssignments } from '@/shared/components/security/HasAssignments';
import { mapInvoiceStreamName, mapResourceName } from '@/shared/services/ObjectDisplayService';
import Checkbox from '@/shared/components/input/Checkbox';
import FormattedListValue from '@/shared/components/FormattedListValue';
import FormattedCurrency from '@/shared/components/FormattedCurrency';
import intlShape from '@/shared/utils/intlShape';
import { guid1 } from '@/shared/utils/guid';
import DataCacheService from '@/shared/services/DataCacheService';
import PlannedRegistrationQuantity from './PlannedRegistrationQuantity';
import FormattedDateShort from '../../../shared/components/FormattedDateShort';
import messages from './messages';

const PlannedRegistrationOverviewRow = ({
  row,
  selected,
  intl,
  handleSelect,
  disableSelect,
  showPrices,
  columnStatus,
}) => {
  const { planning } = row;
  const user = useMemo(() => {
    if (!planning?.userId) return null;
    return planning.userId === guid1
      ? intl.formatMessage(messages.SystemUser)
      : DataCacheService.getUserName(planning.userId);
  }, [planning?.userId, intl]);

  return (
    <tbody className="hover" key={row.key} id={`RowID${row.key}`}>
      <tr>
        <td>
          <Checkbox onClick={() => handleSelect(row)} value={selected} disabled={disableSelect} />
        </td>
        <td>
          <RelationName relation={row.relation} />
        </td>
        {columnStatus.relationUniqueIdentifier && <td>{row.relation.uniqueIdentifier}</td>}
        {columnStatus.relationCode && <td>{row.relation.customerCode}</td>}
        {hasAssignments() && <td>{mapInvoiceStreamName(row.invoiceStream, intl)}</td>}
        <td>
          {planning && planning.scheduleId && (
            <FormattedListValue
              list="plannedRegistrationSchedule"
              id={planning.scheduleId}
              fallback={planning.scheduleName}
            />
          )}
        </td>
        <td>
          {planning && planning.nextPlanningDate && (
            <FormattedDateShort value={planning.nextPlanningDate} />
          )}
        </td>
        <td>
          {planning && planning.startDate && <FormattedDateShort value={planning.startDate} />}
          {planning && planning.startDate && planning.endDate && ' - '}
          {planning && planning.endDate && <FormattedDateShort value={planning.endDate} />}
        </td>
        <td>{planning && mapResourceName(planning.resource, intl)}</td>
        <td>{planning && <PlannedRegistrationQuantity planning={planning} />}</td>
        {columnStatus.user && <td>{user}</td>}
        {showPrices && <td>{planning && <FormattedCurrency value={planning.amount} />}</td>}
        {showPrices && <td>{planning && <FormattedCurrency value={planning.totalAmount} />}</td>}
        <td>{/* actions */}</td>
      </tr>
    </tbody>
  );
};
PlannedRegistrationOverviewRow.propTypes = {
  row: PropTypes.shape({}).isRequired,
  selected: PropTypes.bool,
  handleSelect: PropTypes.func,
  intl: intlShape.isRequired,
  disableSelect: PropTypes.bool,
  showPrices: PropTypes.bool,
  columnStatus: PropTypes.shape({}).isRequired,
};
PlannedRegistrationOverviewRow.defaultProps = {
  selected: false,
  disableSelect: false,
  handleSelect: () => {},
  showPrices: false,
};
export default PlannedRegistrationOverviewRow;
